import Skeleton from "react-loading-skeleton";

type Props = {
  salesPrice: string;
  listPrice: string;
  isLoading?: boolean;
};

export const PriceView = ({ salesPrice, listPrice, isLoading }: Props) => {
  return (
    <>
      <div className="p-0 w-100">
        <div className="sales">
          <span className="mr-0 cart-price price-plp price-not-found price-pdp">
            <span
              className={
                salesPrice < listPrice
                  ? "develop__ps-product__price develop___Color_SalePrice__red"
                  : "develop__ps-product__price develop___Color_SalePrice__dark"
              }
              style={{ fontSize: "28px" }}>
              {isLoading ? <Skeleton /> : <>${salesPrice}</>}
            </span>
          </span>
        </div>
      </div>
      <div
        className={
          salesPrice < listPrice ? "p-0 w-100 text-left mb-5" : "p-0 w-100"
        }>
        <span
          className="value"
          content={salesPrice < listPrice ? listPrice : ""}>
          {salesPrice < listPrice ? (
            <span
              className="strike-through cart-price price-plp price-not-found price-pdp develop___subrayado"
              style={{ fontSize: "22px" }}>
              {" "}
              {isLoading ? <Skeleton /> : <>${listPrice}</>}
            </span>
          ) : (
            <span className="strike-through cart-price price-plp price-not-found price-pdp develop___subrayado">
              {""}
            </span>
          )}
        </span>
      </div>
    </>
  );
};
